import axios from 'axios';

const API_URL = 'https://cnrevtawb7.execute-api.us-west-2.amazonaws.com/prod/api/';

// const API_URL = 'http://localhost:5085/api/';

const authApi = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor to include the authorization header with the token
authApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default authApi; 